module.exports = __webpack_public_path__ + "static/img/guarantee1.58bf2c22.png";